import Box from '@mui/material/Box';
import { Stack } from '@mui/material';
import React from 'react';
import AddButton from '../../../Buttons/AddButton';
import useCadastreTabs from '../../../../hooks/useCadastreTabs';
import NavTabs from '../../../Tabs';
import CustomInput from '../../../Inputs';
import PhoneInput from '../../../Inputs/PhoneInput';
import DeleteButton from '../../../Buttons/DeleteButton';
import { useDeleteCadastreEntity } from '../../../../hooks/cadastre/useDeleteCadastreEntity';
import { validatePhone } from '../../../../helpers';
import { cadastreReportResponsiblePersons } from '../../../../api/cadastreApi';
import { METHODS_API } from '../../../../api/api';
import { Text } from '../../../Text';
import { fullWidth } from '../../../../constants/lkCadastr/cadastrStorage';

export function ResponsiblePerson({
  isDemo,
  changeField,
  responsiblePersons,
  onAddResponsiblePerson,
  onDeleteResponsiblePerson,
}) {
  const { tabs: responsiblePersonsTabs, tab: responsiblePersonsTab, setTab: setSelectedTab } = useCadastreTabs({
    items: responsiblePersons,
    tabName: 'Ответственное лицо',
  });

  const { openDeleteModal } = useDeleteCadastreEntity();

  const onDeletePerson = async (person, index) => {
    const updatePersons = responsiblePersons.slice();

    if (person.id) {
      const deletedId = await cadastreReportResponsiblePersons({ method: METHODS_API.DELETE, id: person.id });

      if (!deletedId) return;
    }

    updatePersons.splice(index, 1);
    if (onDeleteResponsiblePerson) onDeleteResponsiblePerson(updatePersons);
  };

  return (
    <Stack gap="16px">
      <Box>
        Ответственное лицо за составление формы
      </Box>
      {((responsiblePersons?.length !== 3) && !isDemo) && (
        <AddButton variant="outlined" onClick={onAddResponsiblePerson}>
          Добавить ответственное лицо
        </AddButton>
      )}
      <NavTabs
        tabsComponents={responsiblePersonsTabs}
        setTab={setSelectedTab}
        tab={responsiblePersonsTab}
      />
      {responsiblePersons.map((responsiblePerson, responsiblePersonIndex) => {
        if (responsiblePerson.randId !== responsiblePersonsTab) return null;
        return (
          <Stack gap="16px" key={responsiblePerson.randId}>
            {!isDemo && responsiblePersons?.length !== 1 && (
              <Stack direction="row" alignItems="center" gap="4px">
                Ответственное лицо №
                {responsiblePersonIndex + 1}
                <DeleteButton
                  onClick={() => openDeleteModal(() => onDeletePerson(responsiblePerson, responsiblePersonIndex), responsiblePersonIndex, 'Ответственное лицо')}
                >
                  Удалить ответственного
                </DeleteButton>
              </Stack>
            )}

            <Box>
              <Text className="mute">ФИО</Text>
              <CustomInput
                validImmediately
                debounceTime={0}
                disabled={isDemo}
                sx={fullWidth}
                value={responsiblePerson.fio}
                error={responsiblePerson.fio.length > 255 && 'ФИО не может быть длиннее 255 символов'}
                onChange={(e, value) => {
                  changeField('fio', responsiblePersonIndex, value);
                }}
              />
            </Box>
            <Box>
              <Text className="mute">Должность</Text>
              <CustomInput
                validImmediately
                debounceTime={0}
                disabled={isDemo}
                sx={fullWidth}
                value={responsiblePerson.position}
                error={responsiblePerson.position.length > 255 && 'Должность не может быть длиннее 255 символов'}
                onChange={(e, value) => {
                  changeField('position', responsiblePersonIndex, value);
                }}
              />
            </Box>
            <Box>
              <Text className="mute">Телефон</Text>
              <PhoneInput
                validImmediately
                type="tel"
                name="phone_num"
                label=""
                disabled={isDemo}
                sx={fullWidth}
                value={responsiblePerson.phone_num}
                error={(responsiblePerson.phone_num === '' && 'Есть незаполненные поля')
                                  || (!validatePhone(responsiblePerson.phone_num) && 'Некорректный номер')}
                onChange={(e, value) => {
                  changeField('phone_num', responsiblePersonIndex, value);
                }}
              />
            </Box>
          </Stack>
        );
      })}
    </Stack>
  );
}
